import { initializeApp } from "firebase/app"
import { getFirestore } from "firebase/firestore"
import { getAnalytics } from "firebase/analytics"
import { getAuth } from "firebase/auth";

// Minimal Firebase config for frontend (only what's needed for auth UI)
const picassoFirebaseConfig = {
  apiKey: import.meta.env.VITE_PICASSO_BASE_API_KEY,
  authDomain: import.meta.env.VITE_BASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_BASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_BASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_BASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_PICASSO_APP_ID,
  measurementId: import.meta.env.VITE_PICASSO_MEASUREMENT_ID,
}

const picassoApp = initializeApp(picassoFirebaseConfig, 'picasso')
const picassoAnalytics = getAnalytics(picassoApp)
const picassoDb = getFirestore(picassoApp)
const picassoAuth = getAuth(picassoApp)

export { picassoDb as db, picassoAnalytics as analytics, picassoAuth as auth }